import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQuery,
  tagTypes: ['userList'],
  endpoints: (builder) => ({
    getUserList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getUserList');
      },
      providesTags: ['userList'],
    }),

    addNewUser: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'addNewUser');
      },
      invalidatesTags: ['userList'],
    }),
    updateUserProfile: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'updateUser');
      },
    }),
  }),
});

export const {
  useLazyGetUserListQuery,
  useGetUserListQuery,
  useAddNewUserMutation,
  useUpdateUserProfileMutation,
} = userApi;
